import React, { Component } from "react";
import api from "../../../api/api";
import CookieHandler from "../../common/CookieHandler";
import PreShipmentInspectionAdd from "./Pre-Shipment-Inspection-Add";
import PreShipmentInspectionView from "./Pre-Shipment-Inspection-View";
import PreShipmentInspectionUpdate from "./Pre-Shipment-Inspection-update";

import { TextField, Snackbar, Checkbox } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Drawer from "@material-ui/core/Drawer";
import config from "../../../config/config";
import { withStyles } from "@material-ui/core/styles";
import DeleteConfirmation from "../../common/DeleteConfirmation";
import { pad } from "../../common/common";
import Loader from "../../common/Loader";

const CheckBox = withStyles({
  root: {
    color: "#ccc",
    "&$checked": {
      color: config.themeColor,
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default class PreShipmentInspectionList extends Component {
  constructor(props) {
    super(props);
    this.Cookie = new CookieHandler();
    this.state = {
      shipment_costing_list: [],
      isLoading: true,
      barge_nomination: "",
      jetty_name: "",
      features: [],
      business_no_drop_value: [],
      business_no_id: [],
      sampling_surveyors_drop_value: [],
      sampling_surveyors: [],
      showDrawer: false,
      PreShipmentInspectionAdd: false,
      PreShipmentInspectionView: false,
      PreShipmentInspectionUpdate: false,
      bargeCostingID: null,
      shipment_type: "",
      updateDocuments: false,
    };
  }

  async componentDidMount() {
    if (!this.Cookie.isLoggedIn()) {
      this.props.history.replace("/logout");
    } else {
      const features = this.Cookie.getCookie("features");
      this.setState({ features: features });
      if (!(features.includes("167") || features.includes("97"))) {
        window.location.href = "/dashboard";
      }
      const loginUserID = this.Cookie.getCookie("loginUserId");
      const idToken = this.Cookie.getIdTokenCookie();
      api.getBusinessNumbers(loginUserID, idToken).then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              if (res.idtoken) this.Cookie.setIdTokenCookie(res.idtoken);
              if (res.business_numbers) {
                let business_no_drop_value = [];
                for (var i of res.business_numbers) {
                  business_no_drop_value.push({
                    name: i.business_no,
                    value: i.id,
                    mother_vessel_name: i.mother_vessel_name ? i.mother_vessel_name : i.business_no,
                  });
                }
                this.setState({
                  business_no_drop_value: business_no_drop_value,
                  //loading: false,
                });
              } else {
                alert(
                  "Unexpected error occured. Please contact administrator."
                );
              }
            } else if (res.code === "607") {
              window.location.href = "/logout";
            }
          });
        }
      });
      let status = "Active";
      const getVendors = await api.getVendors(loginUserID, idToken, status);
      if (getVendors.status >= 200 && getVendors.status < 300) {
        getVendors.json().then((res) => {
          if (res.code === "200") {
            if (res.vendors) {
              const sampling_surveyors = [];
              for (var i of res.vendors) {
                if (i.vendor_type === "Surveyor") {
                  sampling_surveyors.push({ name: i.vendor_name, value: i.id });
                }
              }
              this.setState({
                sampling_surveyors_drop_value: sampling_surveyors,
                isLoading: false,
              });
            }
          }
        });
      }
    }
  }

  toLocaleString(value) {
    return value ? Number(value).toLocaleString() : 0;
  }

  searchBargeHandler() {
    const loginUserID = this.Cookie.getCookie("loginUserId");
    const idToken = this.Cookie.getIdTokenCookie();

    // if (name === '') {
    //   this.setState({
    //     barge_name_error: true,
    //     snackBarErrorOpen: true,
    //     errorMsg: "Please Fill Mandatory Fields"
    //   });
    //   return;
    // }
    let business_no = this.state.business_no_id;
    let shipment_surveyor = this.state.sampling_surveyors;
    api
      .get_barges_for_barge_pur_fin_pre_shipments(
        loginUserID,
        idToken,
        business_no,
        shipment_surveyor
      )
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              if (res.barges) {
                let newData = [];
                var result = res.barges.reduce(function (r, a) {
                  r[a.id] = r[a.id] || [];
                  r[a.id].push(a);
                  return r;
                }, Object.create(null));
                for (let l = 0; l < Object.keys(result).length; l++) {
                  newData.push({ new_barges: result[Object.keys(result)[l]] });
                }
                let purchase_contracts_barges = newData;
                if (newData.length === 0) {
                  this.setState({
                    snackBarErrorOpen: true,
                    errorMsg: "No records to display",
                  });
                }
                this.setState({
                  shipment_costing_list: purchase_contracts_barges.reverse(),
                  isLoading: false,
                });
              } else {
                alert(
                  "Unexpected error occured. Please contact administrator."
                );
              }
            } else if (res.code === "601") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.message,
              });
            } else if (res.code === "607") {
              window.location.href = "/logout";
            }
          });
        }
      });
  }

  deleteBargePurchaseFinancial = (data) => {
    this.setState({ isLoading: true });
    var loginUserID = this.Cookie.getCookie("loginUserId");
    var idToken = this.Cookie.getIdTokenCookie();
    var barge_pre_shipment_id = data.id;
    api
      .delete_barge_pur_fin_pre_shipment(
        loginUserID,
        idToken,
        barge_pre_shipment_id
      )
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.json().then((res) => {
            if (res.code === "200") {
              this.setState({
                successMsg: res.message,
                errorMsg: "",
                isLoading: false,
                deleteCosting: false,
              });
              this.searchBargeHandler();
            } else if (res.code === "601") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.message,
                isLoading: false,
              });
            } else if (res.code === "607") {
              window.location.href = "/logout";
            } else if (res.code === "624") {
              this.setState({
                snackBarErrorOpen: true,
                errorMsg: res.message,
                isLoading: false,
              });
            } else if (res.code === "650") {
              this.setState({
                deleteCosting: false,
                snackBarErrorOpen: true,
                errorMsg:
                  "Payments are available for this record. Please delete Payments before deleting this record.",
                deleteAlertMsg:
                  "Payments are available for this record. Please delete Payments before deleting this record.",
                // successMsg: "",
                // errorMsg: res.message,
                isLoading: false,
              });
            }
          });
        }
      });
  };

  onUpdateResponse = (value) => {
    if (value === "200") {
      this.setState({
        PreShipmentInspectionUpdate: false,
        PreShipmentInspectionAdd: false,
        PreShipmentInspectionView: true,
        updateDocuments: false,
      });
    }
  };

  onAddResponse = (value) => {
    if (value === "200") {
      this.setState({
        PreShipmentInspectionAdd: false,
        PreShipmentInspectionView: false,
        showDrawer: false,
        updateDocuments: false,
      });
    }
  };

  onCancel = (value) => {
    if (value === false) {
      this.setState(
        {
          PreShipmentInspectionUpdate: false,
          PreShipmentInspectionAdd: false,
          PreShipmentInspectionView: false,
          showDrawer: false,
          bargeCostingID: null,
          updateDocuments: false,
        },
        () => this.searchBargeHandler()
      );
    }
  };

  onEdit = (value) => {
    if (value === true) {
      this.setState({
        PreShipmentInspectionAdd: false,
        PreShipmentInspectionView: false,
        PreShipmentInspectionUpdate: true,
        showDrawer: true,
        updateDocuments: false,
      });
    }
  };

  render() {
    let drawerComponent;
    if (this.state.PreShipmentInspectionAdd) {
      drawerComponent = (
        <PreShipmentInspectionAdd
          onAddResponse={this.onAddResponse}
          onCancel={this.onCancel}
        />
      );
    } else if (
      this.state.PreShipmentInspectionView &&
      this.state.bargeCostingID !== null
    ) {
      drawerComponent = (
        <PreShipmentInspectionView
          costing_id={this.state.bargeCostingID}
          onCancel={this.onCancel}
          onEdit={this.onEdit}
          shipment_type={this.state.shipment_type}
          returnDocumentsHandler={() => {
            this.setState({
              showDrawer: true,
              PreShipmentInspectionUpdate: true,
              PreShipmentInspectionView: false,
              PreShipmentInspectionAdd: false,
              updateDocuments: true,
            });
          }}
        />
      );
    } else if (
      this.state.PreShipmentInspectionUpdate &&
      this.state.bargeCostingID !== null
    ) {
      drawerComponent = (
        <PreShipmentInspectionUpdate
          costing_id={this.state.bargeCostingID}
          onUpdateCosting={this.onUpdateResponse}
          onCancel={this.onCancel}
          shipment_type={this.state.shipment_type}
          updateDocuments={this.state.updateDocuments}
        />
      );
    }
    if (this.state.isLoading) {
      return <Loader />;
    } else {
      return (
        <div className="card">
          <Drawer
            anchor="right"
            open={this.state.showDrawer}
            variant="temporary"
            elevation={20}
            style={{ overflow: "initial" }}
          >
            <div className="row" style={{ width: 800 }}>
              {drawerComponent}
              {this.state.PreShipmentInspectionView &&
                this.state.bargeCostingID !== null && (
                  <div
                    className="row col-lg-12 modal-footer justify-content-end"
                    style={{
                      position: "absolute",
                      bottom: 0,
                      background: "white",
                    }}
                  >
                    <button
                      type="button"
                      className="drawer_button drawer_text drawer_calculate_button drawer_calculate_adjustment"
                      onClick={() =>
                        this.setState({
                          PreShipmentInspectionUpdate: false,
                          PreShipmentInspectionAdd: false,
                          PreShipmentInspectionView: false,
                          showDrawer: false,
                          bargeCostingID: null,
                        })
                      }
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="drawer_button drawer_text"
                      onClick={() =>
                        this.setState({
                          PreShipmentInspectionUpdate: true,
                          PreShipmentInspectionAdd: false,
                          PreShipmentInspectionView: false,
                        })
                      }
                    >
                      Edit
                    </button>
                  </div>
                )}
            </div>
          </Drawer>
          <div className="row mb-1 p-2">
            <div className="col-lg-3 p-0">
              <Autocomplete
                multiple
                options={this.state.business_no_drop_value}
                getOptionLabel={(option) => option.mother_vessel_name}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <CheckBox style={{ marginRight: 8 }} checked={selected} />
                    <div className="col-lg p-0 m-0">
                      <label className="form_label mb-0">
                        {option.mother_vessel_name}
                      </label>
                      <label
                        className="contract_display_header_value m-0 pl-0"
                        style={{ fontSize: 10, paddingLeft: 5 }}
                      >
                        {"( " + option.name + " )"}
                      </label>
                    </div>
                  </React.Fragment>
                )}
                onChange={(event, value) => {
                  if (value) {
                    var data = [];
                    for (var i of value) {
                      data.push(i.value);
                    }
                    //var floating_crane_vendor = data.toString();
                    this.setState({ business_no_id: data });
                  } else {
                    this.setState({ business_no_id: [] });
                  }
                }}
                disableCloseOnSelect
                name="Business_Number"
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Business No"
                    label="Business No"
                    variant="standard"
                    style={{ top: 8 }}
                    fullWidth
                  />
                )}
                style={{ display: "contents" }}
              />
            </div>
            <div className="col-lg-3 pr-0">
              <Autocomplete
                multiple
                options={this.state.sampling_surveyors_drop_value}
                getOptionLabel={(option) => option.name}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option.name}
                  </React.Fragment>
                )}
                onChange={(event, value) => {
                  if (value) {
                    var data = [];
                    for (var i of value) {
                      data.push(i.value);
                    }
                    //var floating_crane_vendor = data.toString();
                    this.setState({ sampling_surveyors: data });
                  } else {
                    this.setState({ sampling_surveyors: [] });
                  }
                }}
                disableCloseOnSelect
                name="Sampling surveyors"
                size="small"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Sampling surveyors"
                    label="Surveyor"
                    variant="standard"
                    style={{ top: 8 }}
                    fullWidth
                  />
                )}
                style={{ display: "contents" }}
              />
            </div>
            <div className="col-lg-2 p-2">
              <button
                className="header_button header_button_text add_button_adjustment"
                style={{ width: "auto", marginTop: "15px" }}
                onClick={() => this.searchBargeHandler()}
              >
                Load
              </button>
            </div>
            {(this.state.features.includes("166") ||
              this.state.features.includes("97")) && (
              <div className="col p-2 text-right float-sm-left">
                <button
                  className="header_button header_button_text add_button_adjustment"
                  style={{ width: "auto", marginTop: "25px" }}
                  onClick={() =>
                    this.setState({
                      PreShipmentInspectionAdd: true,
                      showDrawer: true,
                    })
                  }
                >
                  New
                </button>
              </div>
            )}
          </div>

          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            open={this.state.snackBarErrorOpen}
            onClose={() => this.setState({ snackBarErrorOpen: false })}
            style={{ width: "450px" }}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarErrorOpen: false })}
              severity="error"
              style={{ width: "100%" }}
            >
              {this.state.errorMsg}
            </Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
            style={{ width: "450px" }}
            open={this.state.snackBarSuccessOpen}
            autoHideDuration={100000}
            onClose={() => this.setState({ snackBarSuccessOpen: false })}
          >
            <Alert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ snackBarSuccessOpen: false })}
              severity="success"
              style={{ width: "100%" }}
            >
              {this.state.sucessMsg}
            </Alert>
          </Snackbar>
          {this.state.shipment_costing_list.length > 0 && (
            <div className="row">
              <div className="table-responsive">
                <table className="table table-bordered table-sm mb-0">
                  <thead className="table-header">
                    <tr>
                      <th
                        nowrap="true"
                        className="table_header_barge_label text-uppercase"
                      ></th>
                      <th
                        nowrap="true"
                        className="table_header_barge_label text-uppercase"
                      >
                        Costing ID
                      </th>
                      <th
                        nowrap="true"
                        className="table_header_barge_label text-uppercase"
                      >
                        Barge ID
                      </th>
                      <th
                        nowrap="true"
                        className="table_header_barge_label text-uppercase"
                      >
                        Barge Nomination
                      </th>
                      <th
                        nowrap="true"
                        className="table_header_barge_label text-uppercase"
                      >
                        Business No
                      </th>
                      <th
                        nowrap="true"
                        className="table_header_barge_label text-uppercase"
                      >
                        Surveyor
                      </th>
                      <th
                        nowrap="true"
                        className="text-right table_header_barge_label text-uppercase"
                      >
                        Quantity
                      </th>
                      <th
                        nowrap="true"
                        className="text-right table_header_barge_label text-uppercase"
                      >
                        Price PMT
                      </th>
                      <th
                        nowrap="true"
                        className="text-right table_header_barge_label text-uppercase"
                      >
                        Total Payable
                      </th>
                      <th
                        nowrap="true"
                        className="text-right table_header_barge_label text-uppercase"
                      >
                        Paid
                      </th>
                      <th
                        nowrap="true"
                        className="text-right table_header_barge_label text-uppercase"
                      >
                        Remaining
                      </th>
                    </tr>
                  </thead>
                  {this.state.shipment_costing_list.map((p, index) => (
                    <tbody key={index}>
                      {p.new_barges.map((idr, indx) => (
                        <tr key={indx} className="rounded">
                          {indx === 0 && (
                            <td
                              className="text-center"
                              nowrap="true"
                              rowSpan={p.new_barges.length}
                            >
                              <i
                                className="fa fa-eye mr-2"
                                aria-hidden="true"
                                style={{
                                  fontSize: 22,
                                  color: config.themeColor,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (idr.barge_id === "0") {
                                    this.setState({
                                      PreShipmentInspectionView: true,
                                      bargeCostingID: idr.id,
                                      showDrawer: true,
                                      shipment_type: "Without Barge",
                                    });
                                  } else {
                                    this.setState({
                                      PreShipmentInspectionView: true,
                                      bargeCostingID: idr.id,
                                      showDrawer: true,
                                      shipment_type: "With Barge",
                                    });
                                  }
                                }}
                              ></i>
                              {(this.state.features.includes("169") ||
                                this.state.features.includes("97")) &&
                                idr.approval_status === "Pending" && (
                                  <i
                                    className="fa fa-trash-o"
                                    aria-hidden="true"
                                    style={{
                                      fontSize: 21,
                                      color: config.themeColor,
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      this.setState({
                                        barge_pur_fin_id: idr.id,
                                        deleteData: idr,
                                        deleteCosting: true,
                                      })
                                    }
                                  ></i>
                                )}
                            </td>
                          )}
                          {indx === 0 && (
                            <td
                              className=" text-left"
                              nowrap="true"
                              rowSpan={p.new_barges.length}
                            >
                              {idr.costing_no}
                            </td>
                          )}
                          <td className="">
                            {idr.barge_id !== "0"
                              ? pad(idr.barge_id)
                              : "Without Barge"}
                          </td>
                          <td className=" text-left" nowrap="true">
                            {idr.barge_nomination ? idr.barge_nomination : "-"}
                          </td>
                          <td className=" text-left" nowrap="true">
                            {idr.business_no ? idr.business_no : "-"}
                          </td>
                          <td className=" text-left" nowrap="true">
                            {idr.sac_sampling_surveyor_name
                              ? idr.sac_sampling_surveyor_name
                              : "-"}
                          </td>
                          {indx === 0 && (
                            <td
                              className=" text-right"
                              nowrap="true"
                              rowSpan={p.new_barges.length}
                            >
                              {this.toLocaleString(idr.barge_quantity)}
                            </td>
                          )}
                          {indx === 0 && (
                            <td
                              className=" text-right"
                              nowrap="true"
                              rowSpan={p.new_barges.length}
                            >
                              {this.toLocaleString(idr.price_per_mt)}
                            </td>
                          )}
                          {indx === 0 && (
                            <td
                              className=" text-right"
                              nowrap="true"
                              rowSpan={p.new_barges.length}
                            >
                              {this.toLocaleString(idr.total_payable)}
                            </td>
                          )}
                          {indx === 0 && (
                            <td
                              className=" text-right"
                              nowrap="true"
                              rowSpan={p.new_barges.length}
                            >
                              {this.toLocaleString(idr.paid)}
                            </td>
                          )}
                          {indx === 0 && (
                            <td
                              className=" text-right"
                              nowrap="true"
                              rowSpan={p.new_barges.length}
                            >
                              {this.toLocaleString(idr.Remaining_amount)}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  ))}
                </table>
              </div>
            </div>
          )}
          {/**
           *
           *  Delete Barge Costing Alert Message Modal
           *
           */}

          {this.state.deleteCosting && (
            <DeleteConfirmation
              open={this.state.deleteCosting}
              close={() => this.setState({ deleteCosting: false })}
              callbackFn={() =>
                this.deleteBargePurchaseFinancial(this.state.deleteData)
              }
            />
          )}
        </div>
      );
    }
  }
}
